import { Layout, Button, Card, Col, Input, message, Row } from 'antd'
import React, { useState, useEffect } from 'react'
import articleStyle from '@/pages/community/article-form/article.module.less'
import OAMSider from '../oam-sider'
import MarkDownEditor, {
  mdParser,
} from '../../../component/MarkDownEditor/MarkDownEditor'
import Cookies from 'js-cookie'
import { sendHttpPostRequest } from '../../../api/http-request'

import {
  CheckCircleOutlined 
} from '@ant-design/icons'


export interface Props {

}



const OAMPostEdit = (props) => {

  const articleId = window.location.search.split('&')[0].split('post_id=')[1]
  const [articleTitle, setArticleTitle] = useState('')
  const [articleContent, setArticleContent] = useState('') // # 
  const [articleLoaded, setArticleLoaded] = useState(false) // 加载中
  const [uploadImageList, setUploadImageList] = useState([] as any [])

  const [savingStatus, setSavingStatus] = useState(false) // 加载中

  useEffect(() => {
    queryArticleContentById()
  }, [])

  const onTitleChange = (e) => {
    setArticleTitle(e.target.value)
  }

  /**
   * 存文章草稿内容
   */
  const saveArticleContent = () => {
    setSavingStatus(false)
    sendHttpPostRequest(
      'community/api/oam_update_post_by_id/',
      {
        sessionid: Cookies.get('sessionid'),
        post_id: articleId,
        title: articleTitle,
        content: articleContent,
      },
      (response: any) => {
        message.destroy()
        if (response.code == -100) {
          // 未登录
          window.location.href = '/oam_login?next=oam_post_list'
        } else if (response.code == 0) {
          // 成功
          setSavingStatus(true)
        } else if (response.code == -501) {
          // 权限不足
          window.location.href = '/oam_login?next=oam_post_list'
        } else {
          message.error(response.message)
        }
      }
    )
  }

  /**
   * 查询文章内容by id
   */
  const queryArticleContentById = () => {
    setArticleLoaded(false)
    sendHttpPostRequest(
        'community/api/oam_query_post_by_id/',
        {
          sessionid: Cookies.get('sessionid'),
          post_id: articleId
        },
        (response: any) => {
          setArticleLoaded(true)
          message.destroy()
          if (response.code == -100) {
            // 未登录
            window.location.href = '/oam_login?next=oam_post_list'
          } else if (response.code == 0) {
            // 成功
            setArticleTitle(response.query_content.title)
            setArticleContent(response.query_content.content)
          } else if (response.code == -501) {
            // 权限不足
            window.location.href = '/oam_login?next=oam_post_list'
          } else {
            message.error(response.message)
          }
        }
    )
  }

  const onEditorChange = ({ html, text }) => {
    setArticleContent(text)
  }

  const uploadOption = {
    name: "community_picture",
    actionUrl: "community/api/upload_picture/",
    uploadData: { sessionid: Cookies.get('sessionid') },
    uploadImageList: uploadImageList,
    setUploadImageList: setUploadImageList
  }

  return (
    <Layout style={{ minHeight: '100vh',minWidth:1200 }}>
        <OAMSider keys={['888']} openKeys={[]} />
        <Layout style={{ backgroundColor: '#f9f9f9' }}>
            <div className={articleStyle.articleMain}>
            <Card
                bodyStyle={{
                padding: '30px 60px 80px 60px',
                minHeight: '970px',
                }}
                extra={
                <span style={{ cursor: 'pointer' }} onClick={() => window.location.href = '/oam_post_list'}>
                    {'返回>'}
                </span>
                }
                className={articleStyle.articleCard}
                title={ <> 编辑文章 {savingStatus == true && <span style={{marginLeft:10, color:'#07c160'}}><CheckCircleOutlined /> <span style={{marginLeft:5, fontSize:14, color:'#666'}}>已保存 </span></span> }</>
                }
            >
                <Row className={articleStyle.row} align={'middle'} wrap={false}>
                <Col className={articleStyle.title}>标题</Col>
                <Col flex={'auto'}>
                    <Input
                    className={articleStyle.input}
                    value={articleTitle}
                    onChange={onTitleChange}
                    onBlur={() => {
                        articleTitle != '' ? saveArticleContent() : ''
                    }}
                    placeholder={'请输入文章标题'}
                    autoFocus
                    />
                </Col>
                </Row>
                <Row className={articleStyle.row} align={'top'} wrap={false}>
                <Col className={articleStyle.title}>内容</Col>
                <Col className={articleStyle.editorContain}>
                    <MarkDownEditor
                    onChange={onEditorChange}
                    onBlur={() => {
                        saveArticleContent()
                    }}
                    preview
                    toolbar={'all'}
                    height={720}
                    value={articleContent}
                    uploadOption={uploadOption}
                    />
                </Col>
                </Row>
            </Card>
            <Row
            className={articleStyle.actionFooter}
            justify={'center'}
            align={'middle'}
            >
            <Col>
                <Button style={{color:'#07c160', border:'solid 1px #07c160', marginRight: '60px' ,  width:80, textShadow:'none', boxShadow:'none'}}  onClick={() => {window.open('/community-article-detail?id=' + articleId)}} >
                预览
                </Button>
            </Col>

            <Col>
                <Button  style={{width:80, textShadow:'none', boxShadow:'none'}} type={'primary'} onClick={saveArticleContent}>
                保存
                </Button>
            </Col>
            </Row>
            </div>
        </Layout>
    </Layout>
  )
}

export default OAMPostEdit
